module.exports = __webpack_public_path__ + "media/application/images/icons/icon-blended-finance-1c5a7f0211d5762355bba47ac9469283.svg";